export const PENDING = 'pending';
export const REJECTED = 'rejected';
export const CONFIRMED = 'confirmed';
